import { Link } from "react-router-dom";
import { Check, X, Star } from "@phosphor-icons/react";
import { TIERS, FEATURE_MATRIX, eurHint } from "../lib/offers";

function FeatureLine({ label, included }) {
  return (
    <li className="flex items-start gap-2 text-sm py-1">
      {included
        ? <Check size={16} weight="bold" color="#2E7D5B" className="shrink-0 mt-0.5" />
        : <X size={16} weight="bold" className="shrink-0 mt-0.5 text-[#16233D]/25" />}
      <span className={included ? "text-[#16233D]/85" : "text-[#16233D]/35 line-through decoration-[#16233D]/20"}>{label}</span>
    </li>
  );
}

function TierCard({ tier }) {
  const isCustom = tier.id === "custom";
  return (
    <div data-testid={`pricing-card-${tier.id}`}
      className={`relative flex flex-col rounded-[22px] p-6 bg-white border transition-shadow hover:shadow-[0_8px_30px_-6px_rgba(22,35,61,0.14)] ${
        tier.featured ? "border-[#C9793A] border-2 shadow-[0_8px_30px_-4px_rgba(201,121,58,0.20)]" : "border-[#E9E4DA]"}`}>
      {tier.featured && (
        <span className="absolute -top-3 left-6 inline-flex items-center gap-1 bg-[#C9793A] text-white text-xs font-semibold px-3 py-1 rounded-full">
          <Star size={12} weight="fill" /> Recommandé
        </span>
      )}
      <h3 className="font-display font-bold text-2xl">{tier.name}</h3>
      <p className="text-sm text-[#16233D]/60 mt-1 mb-5 min-h-[40px]">{tier.target}</p>

      {tier.price ? (
        <p className="font-display font-bold text-3xl lg:text-4xl tabular-nums leading-none">
          {tier.price}
          <span className="block text-sm font-normal text-[#16233D]/55 mt-1.5">GNF{tier.frequency}</span>
          <span data-testid={`pricing-eur-${tier.id}`} className="block text-xs font-normal text-[#16233D]/45 mt-1">
            {eurHint(Number(tier.price.replace(/\s/g, "")))}
          </span>
          <span className="block text-[11px] font-normal text-[#16233D]/35 mt-0.5">
            Montant facturé en GNF ; l'équivalent en euros est indicatif.
          </span>
        </p>
      ) : (
        <p className="font-display font-bold text-3xl lg:text-4xl leading-none">
          Sur mesure
          <span className="block text-sm font-normal text-[#16233D]/55 mt-1.5">Tarif négocié selon vos besoins</span>
        </p>
      )}

      <Link to={tier.href} data-testid={`pricing-cta-${tier.id}`}
        className={`mt-5 w-full text-center py-3 ${tier.featured || !isCustom ? "btn-amber" : "btn-ghost"}`}>
        {tier.cta}
      </Link>

      <div className="h-px bg-[#E9E4DA] my-6" />

      <p className="text-xs font-semibold uppercase tracking-wider text-[#16233D]/50 mb-2">Fonctionnalités</p>
      <ul className="mb-6">
        {FEATURE_MATRIX.map((f) => (
          <FeatureLine key={f.name} label={f.name} included={f.tiers.includes(tier.id)} />
        ))}
      </ul>

      <p className="text-xs font-semibold uppercase tracking-wider text-[#16233D]/50 mb-2 mt-auto">
        {isCustom ? "Inclus à ce niveau" : "Quotas"}
      </p>
      <ul className="space-y-1">
        {(isCustom ? tier.included : tier.quotas).map((q) => (
          <li key={q} className="flex items-start gap-2 text-sm text-[#16233D]/80">
            <Check size={15} weight="bold" color="#C9793A" className="shrink-0 mt-0.5" />
            <span className="font-mono-doc text-[13px]">{q}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function PricingCards() {
  return (
    <div data-testid="pricing-grid" className="grid gap-5 md:grid-cols-2 xl:grid-cols-4 items-stretch">
      {TIERS.map((t) => <TierCard key={t.id} tier={t} />)}
    </div>
  );
}
